export function fullTrain(t: any, literal: string = 'literals.fullTrain') {
    return {
        price: 0,
        text: `${t("literals.fullTrain")}`,
        type: "warn"
    }
}
export function includedMainText(t: any, literal: string = 'literals.mainTicketIncluded') {
    return {
        price: null,
        text: `${t(literal)}`,
        type: "info",
        informative:true,
    }
}
export function externalBuy(t: any, price: number = 0, literal: string = 'literals.requiresExternalPurchase') {
    return {
        price: 0,
        text: `${t(literal)} (${price ? formatPrice(price) + '€' : t('literals.requiresExternalPurchaseNoPrice')})`,
        type: "warn",
        informative:true,
    }
}
export function aproxPrice(price: string) {
    return {
        price: price,
        text: `${price} €`,
        type: "info"
    }
}
export function notAvailable(t: any, literal: string = 'literals.notAvailable') {
    return {
        price: 0,
        text: t(literal),
        type: "info"
    }
}


/* SINGLETONS */
/**
 * @description Función que formatea el precio con coma y dos dígitos.
 * @param price Precio a formatear (string o numérico)
 * @returns Precio formateado en X,XX
 */
function formatPrice(price: string | number) {
    let text = price + '';
    let coste = parseFloat(text).toFixed(2);
    let priceFormatted = coste.replace('.', ',');
    return priceFormatted;
}
